export const METERS_CONFIG = {
  serialNumber: {
    key: "serialNumber",
    label: "No. Serie",
  },
  brand: {
    key: "brand",
    label: "Marca",
  },
  model: {
    key: "model",
    label: "Modelo",
  },
  installationDate: {
    key: "installationDate",
    label: "Fecha de instalacion",
  },
  releaseDate: {
    key: "registrationDate",
    label: "Fecha de alta",
  },
  lastReading: {
    key: "lastCapture",
    label: "Fecha lectura",
  },
  capture: {
    key: "currentCapture",
    label: "Lectura",
  },
  status: {
    key: "status",
    label: "Estatus",
  },
};

export const METERS_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Medidores",
    },
  },
  modal: {
    titles: {
      edit: "Modificar Medidor",
      add: "Agregar Nuevo Medidor",
      delete: "¿Estas seguro de eliminar este medidor?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      edit: "Editar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
  form: {
    dropdowns: {
      brand: "Seleccione una Marca",
      model: "Seleccione un Modelo",
      status: "Seleccione un Estatus",
    },
  },
};
